module.exports = __webpack_public_path__ + "img/Ping-Pong.d42f4e97.svg";